/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fully_ProcessedInputs */

const en_fully_processed = /** @type {(inputs: Fully_ProcessedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fully Processed`)
};

const es_fully_processed = /** @type {(inputs: Fully_ProcessedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completamente Procesado`)
};

const fr_fully_processed = /** @type {(inputs: Fully_ProcessedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entièrement traité`)
};

const de_fully_processed = /** @type {(inputs: Fully_ProcessedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständig bearbeitet`)
};

const id_fully_processed = /** @type {(inputs: Fully_ProcessedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diproses Sepenuhnya`)
};

/** @type {(inputs: Fully_ProcessedInputs) => LocalizedString} */
const ja_fully_processed = en_fully_processed;

/** @type {(inputs: Fully_ProcessedInputs) => LocalizedString} */
const zh_fully_processed = en_fully_processed;

/** @type {(inputs: Fully_ProcessedInputs) => LocalizedString} */
const ar_fully_processed = en_fully_processed;

/** @type {(inputs: Fully_ProcessedInputs) => LocalizedString} */
const it_fully_processed = en_fully_processed;

/** @type {(inputs: Fully_ProcessedInputs) => LocalizedString} */
const ru_fully_processed = en_fully_processed;

/** @type {(inputs: Fully_ProcessedInputs) => LocalizedString} */
const pt_fully_processed = en_fully_processed;

/** @type {(inputs: Fully_ProcessedInputs) => LocalizedString} */
const ko_fully_processed = en_fully_processed;

/**
* | output |
* | --- |
* | "Fully Processed" |
*
* @param {Fully_ProcessedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const fully_processed = /** @type {((inputs?: Fully_ProcessedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fully_ProcessedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fully_processed(inputs)
	if (locale === "es") return es_fully_processed(inputs)
	if (locale === "fr") return fr_fully_processed(inputs)
	if (locale === "de") return de_fully_processed(inputs)
	if (locale === "ja") return ja_fully_processed(inputs)
	if (locale === "zh") return zh_fully_processed(inputs)
	if (locale === "ar") return ar_fully_processed(inputs)
	if (locale === "id") return id_fully_processed(inputs)
	if (locale === "it") return it_fully_processed(inputs)
	if (locale === "ru") return ru_fully_processed(inputs)
	if (locale === "pt") return pt_fully_processed(inputs)
	return ko_fully_processed(inputs)
});